import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { customInMemoryCache } from "./cache";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { store } from "../store/store";
import { logoutUser } from "../store/userSlice";




const URL = process.env.REACT_APP_GRAPHQL_URL ;


const httpLink = createUploadLink({
  uri: URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("mamaketUserToken") ;


  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
         "content-type": "application/json",
        'apollo-require-preflight': true,
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
      
      // Check for authentication errors
      if (extensions?.code === 'UNAUTHENTICATED' || message.includes('Not authorized')) {
        console.log('Authentication error detected, logging out user');
        store.dispatch(logoutUser());
        window.location.href = '/login';
      }
    });
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
    
    // Check for 401 Unauthorized responses
    if (networkError.statusCode === 401) {
      console.log('401 Unauthorized detected, logging out user');
      store.dispatch(logoutUser());
      window.location.href = '/login';
    }
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink).concat(httpLink),
  cache: customInMemoryCache,
});

export default client;
